import { CompanyUserList } from '../model/company-user-list';
import { CompanyUserBuilder } from './company-user-builder';
export class CompanyUserListBuilder {
    static buildCompanyUserList(data) {
        let userList = new CompanyUserList();
        userList.users = this.buildUserList(data.users);
        userList.invitations = this.buildUserList(data.invitations);
        return userList;
    }
    static buildUserList(data) {
        let userList = [];
        for (let user of data) {
            userList.push(CompanyUserBuilder.buildCompanyUser(user));
        }
        return userList;
    }
}
//# sourceMappingURL=company-user-list-builder.js.map